import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FeatureEffects } from './effects';
import { featureReducer } from './reducer';
import { WorkspacesFeature } from './selectors';

@NgModule({
  imports: [
    StoreModule.forFeature(WorkspacesFeature, featureReducer),
    EffectsModule.forFeature([FeatureEffects]),
  ],
})
export class WorkspacesStoreModule {}
